{{#if isPipelined}}
virtual function void initialize_state();
  {{ activeTransactionsVariable.identifier }}.delete();
  {{ numActiveTransactionsVariable.identifier }} = 0;
endfunction
{{/if}}
